export default __webpack_public_path__ + "static/media/Diana (1).feee1f1a.jpg";